import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';
import { ContactReponseDTO } from '../creneaux/contact-reponse.dto';
import { UserEvent } from './user-event.model';

export class SetContactReponseEvent extends UserEvent {
  public static NAME = 'SET_CONTACT_REPONSE_EVENT';

  constructor(
    public idCreneau: string,
    public fin: dayjs.Dayjs,
    public coordinates: Coordinates | undefined,
    public readonly contactReponse: ContactReponseDTO
  ) {
    super(SetContactReponseEvent.NAME, fin, coordinates);
  }

  public static hydrate(obj: SetContactReponseEvent): SetContactReponseEvent {
    return new SetContactReponseEvent(obj.idCreneau, dayjs(obj.fin), obj.coordinates, obj.contactReponse);
  }
}
